import { makeStyles } from "@mui/styles";

export const useTimePickerStyles = makeStyles(() => ({
    root: {
        width: "100%",
    },
    helperText: {
        color: "rgba(0, 0, 0, 0.54)",
    },
    menuPaper: {
        maxHeight: 250,
    },
}));
